import {
	goodkindHQEmail,
	goodkindOnlyEmail,
	weAreGoodkindEmail,
	nicheEmail,
} from '@app/constants';

export function checkIsGKAdmin(userEmail: string): boolean {
	if (!userEmail) return false;

	const isWeAreGoodkindUser = userEmail.includes(weAreGoodkindEmail);
	const isGoodkindHQUser = userEmail.includes(goodkindHQEmail);
	const isGoodkindUser = userEmail.includes(goodkindOnlyEmail);
	const isNicheUser = userEmail.includes(nicheEmail);
	return (
		isWeAreGoodkindUser || isGoodkindHQUser || isGoodkindUser || isNicheUser
	);
}

export default checkIsGKAdmin;
